import Fuse from 'fuse.js';
import { normalizeStringToCompare } from '@/utils/convert-string';

export type SearchResult = {
  values: string[];
  foundPerfectMatch: boolean;
};

export interface SearchToolInterface {
  search(value: string): SearchResult;
}

type Item = {
  value: string;
  searchField: string;
};

const MIN_MATCH_CHAR_LENGTH = 2;
const THRESHOLD_FOR_PERFECT_MATCH = 0.001;

export class SearchTool implements SearchToolInterface {
  protected list: string[];

  private engine: Fuse<Item>;

  constructor(list: string[]) {
    this.list = list;
    this.engine = new Fuse<Item>(
      list.map<Item>((item) => ({
        value: item,
        searchField: normalizeStringToCompare(item),
      })),
      {
        threshold: 0.4,
        keys: ['searchField'],
        ignoreLocation: true,
        useExtendedSearch: true,
        includeScore: true,
      },
    );
  }

  search(value: string): SearchResult {
    const normalizedValue = normalizeStringToCompare(value);

    if (normalizedValue.length < MIN_MATCH_CHAR_LENGTH) {
      return { values: this.list, foundPerfectMatch: false };
    }

    const searchResult = this.engine.search(normalizedValue);

    return {
      values: searchResult.map((result) => result.item.value),
      foundPerfectMatch: (searchResult[0]?.score ?? 1) < THRESHOLD_FOR_PERFECT_MATCH,
    };
  }
}
